import { useHistory } from "react-router-dom";
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import BX24Wrapper from "../bx24-wrapper";

function LoadingPage() {
    const history = useHistory();

    const [retailCrmAddress, setRetailCrmAddress] = useState(localStorage.getItem("retailCrmAddress") || '');
    const [retailCrmKey, setRetailCrmKey] = useState(localStorage.getItem("retailCrmKey") || '');

    const [groupsLoaded, setGroupsLoaded] = useState(false);
    const [usersLoaded, setUsersLoaded] = useState(false);
    const [groupsProductsLoaded, setGroupsProductsLoaded] = useState(false);
    const [productsLoaded, setProductsLoaded] = useState(false);
    const [clientsLoaded, setClientsLoaded] = useState(false);
    const [ordersLoaded, setOrdersLoaded] = useState(false);
    const [tasksLoaded, setTasksLoaded] = useState(false);

    useEffect(() => doRequests(), []);

    useEffect(function () {
        setTimeout(function () {
            BX24.fitWindow();
        }, 500)
    }, []);

    async function doRequests() {
        try {
            // группы пользователей
            console.group('user groups');
            const groupsUsersResult = await getGroupsUsers();
            const retailCrmGroups = groupsUsersResult.data.groups;
            const groups = await createGroups(retailCrmGroups);
            await timeout(1000);
            console.groupEnd();

            // пользователи
            console.group('users');
            const usersResult = await getUsers();
            const retailCrmUsers = usersResult.data.users;
            await createUsers(retailCrmUsers, groups);
            const users = await getNewUsers(retailCrmUsers);
            await userSetDepartmentId(users, retailCrmUsers, groups);
            await timeout(1000);
            console.groupEnd();

            //группы товаров
            console.group('product categories');
            const groupsProductsResult = await getGroupsProducts();
            const groupsProducts = groupsProductsResult.data.productGroup;
            const productGroups = await createGroupsProducts(groupsProducts);
            await timeout(1000);
            console.groupEnd();

            // товары
            console.group('products');
            const productsResult = await getProducts();
            const retailCrmProducts = productsResult.data.products;
            const products = await createProducts(retailCrmProducts, productGroups);
            await timeout(1000);
            console.groupEnd();

            // клиенты
            console.group('clients');
            const clientsResult = await getClients();
            const retailCrmCients = clientsResult.data.customers;
            const clients = await createClients(retailCrmCients);
            await timeout(1000);
            console.groupEnd();


            // заказы
            console.group('orders');
            const ordersResult = await getOrders();
            const orders = ordersResult.data.orders;
            await createOrders(orders, clients, products, users, retailCrmProducts);
            await timeout(1000);
            console.groupEnd();

            // задачи
            console.group('tasks');
            const tasksResult = await getTasks();
            const tasks = tasksResult.data.tasks;
            await createTasks(tasks, clients, users, orders);
            console.groupEnd();
            await timeout(500);
            openSuccessPage();
        } catch (err) {
            console.error(err);
            openErrorPage();
        }

    }

    function timeout(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    /**
     * Создать задачи
     * @param tasks
     * @param clients
     * @param users
     * @param orders
     * @returns {Promise<{}>}
     */
    async function createTasks(tasks, clients, users, orders) {
        let calls = [];
        let bx24 = new BX24Wrapper();
        let resultTasks = {};

        let existingTasks = [];
        let existingProgressTasks = await bx24.callListMethod('tasks.task.list',
            {
                order: { "ID": "ASC" },
                filter: {},
                select: ["ID", "XML_ID"]
            });
        if (existingProgressTasks.length > 0) {
            for (let existingTaskArray of existingProgressTasks) {
                if (typeof existingTaskArray.tasks !== typeof undefined) {
                    for (let existingTask of existingTaskArray.tasks) {
                        existingTasks.push(existingTask);
                    }
                }
            }
        }

        for (const key of Object.keys(tasks)) {
            let task = tasks[key];

            for (let existingTask of existingTasks) {
                if (existingTask.xmlId == null) {
                    continue;
                }
                if (existingTask.xmlId == task.id) {
                    resultTasks[task.id] = existingTask.id;
                }
            }


            if (typeof resultTasks[task.id] === typeof undefined) {
                let taskLinks = [];
                if (task.customer !== null) {
                    taskLinks.push("C_" + clients[task.customer.id]);
                }
                if (task.order !== null) {
                    taskLinks.push("D_" + orders[task.order.id])
                }


                calls.push(['tasks.task.add', {
                    fields: {
                        TITLE: task.text,
                        DESCRIPTION: task.commentary,
                        STATUS: task.complete ? 5 : 2,
                        XML_ID: task.id,
                        RESPONSIBLE_ID: task.performerType == "user" ? users[task.performer] : 1,
                        UF_CRM_TASK: taskLinks,
                        DEADLINE: task.datetime != null ? task.datetime.date : ''
                    }
                }]);
            }
        }
        if (calls.length > 0) {
            await bx24.callLongBatch(calls);
        }
        setTasksLoaded(true);
        return resultTasks;
    }

    /**
     * Создать заказы
     * @param orders
     * @param clients
     * @param products
     * @param managers
     * @returns {Promise<void>}
     */
    async function createOrders(orders, clients, products, managers, retailCrmProducts) {
        let bx24 = new BX24Wrapper();
        let calls = [];

        let resultOrders = {};
        let createdOrders = [];
        let basketCalls = [];

        let existingOrders = await bx24.callListMethod('crm.deal.list',
            {
                order: { "NAME": "ASC" },
                filter: {},
                select: ["ID", "TITLE"]
            });
        for (const key of Object.keys(orders)) {
            let order = orders[key];

            for (let existingOrder of existingOrders) {
                if (existingOrder.TITLE == "Заказ №" + order.number) {
                    resultOrders[order.id] = existingOrder.ID;
                }
            }

            if (typeof resultOrders[order.id] === typeof undefined) {
                calls.push(['crm.deal.add', {
                    fields: {
                        TITLE: "Заказ №" + order.number,
                        CONTACT_ID: clients[order.customer.id],
                        OPPORTUNITY: order.totalSumm,
                        IS_MANUAL_OPPORTUNITY: 'Y',
                        OPPORTUNITY_USER: order.totalSumm,
                        CURRENCY_ID: "RUB",
                        ASSIGNED_BY_ID: order.managerId !== null ? managers[order.managerId] : null,
                        COMMENTS: (order.delivery.address !== null && order.delivery.address.text !== null) ? 'Адрес доставки: ' + order.delivery.address.text : ''
                    }
                }]);
                createdOrders.push(order.id);
            }
        }

        if (calls.length > 0) {
            // снять
            await bx24.callLongBatch(calls);
            existingOrders = await bx24.callListMethod('crm.deal.list',
                {
                    order: { "NAME": "ASC" },
                    filter: {},
                    select: ["ID", "TITLE"]
                });
            for (const key of Object.keys(orders)) {
                let order = orders[key];

                for (let existingOrder of existingOrders) {
                    if (existingOrder.TITLE == "Заказ №" + order.number) {
                        resultOrders[order.id] = existingOrder.ID;
                    }
                }
                if (typeof resultOrders[order.id] !== typeof undefined && createdOrders.includes(order.id)) {
                    let resultBasket = [];

                    for (const keyItems of Object.keys(order.items)) {
                        let item = order.items[keyItems];
                        if (item.status !== 'sold' && item.status !== 'completed' && item.status !== 'saled') continue;
                        if (typeof item.offer !== typeof undefined) {
                            let offerId = item.offer.id;
                            let bFound = false;
                            for (let retailCrmProduct of retailCrmProducts) {
                                if (typeof retailCrmProduct.offers !== typeof undefined) {
                                    for (let offer of retailCrmProduct.offers) {
                                        if (offer.id == offerId) {
                                            item.id == retailCrmProduct.id;
                                            item.newId = products[item.id];
                                            bFound = true;
                                            break;
                                        }
                                    }
                                }
                                if (bFound) {
                                    break;
                                }
                            }

                        } else {
                            item.newId = products[item.id];
                        }
                        resultBasket.push(item);
                    }
                    if (resultBasket.length > 0) {
                        basketCalls.push(await getFillQueries(resultOrders[order.id], resultBasket, order.delivery));
                    }
                }


            }
            if (basketCalls.length > 0) {
                // снять
                await bx24.callLongBatch(basketCalls);
            }
        }
        setOrdersLoaded(true);

        return resultOrders;

    }

    async function getFillQueries(dealId, products, delivery) {
        let basket = [];
        for (let product of products) {
            basket.push(
                {
                    PRODUCT_ID: product.newId,
                    PRODUCT_NAME: product.offer.displayName,
                    PRICE: product.initialPrice,
                    QUANTITY: product.quantity
                }
            );
        }

        if (delivery.cost > 0) {
            let deliveryProductId = await getProductForDelivery();

            basket.push(
                {
                    PRODUCT_ID: deliveryProductId[0]['ID'],
                    PRODUCT_NAME: deliveryProductId[0]['NAME'],
                    PRICE: delivery.cost,
                    QUANTITY: 1
                }
            );
        }
        return ['crm.deal.productrows.set',
            {
                id: dealId,
                rows: basket
            }
        ];
    }

    async function getProductForDelivery() {
        let bx24 = new BX24Wrapper();
        return await bx24.callListMethod('crm.product.list',
            {
                order: { "NAME": "ASC" },
                filter: { 'NAME': 'Доставка' },
                select: ["ID", "NAME", "XML_ID"]
            }
        );
    }


    /**
     * Создать клиентов
     * @param clients
     * @returns {Promise<void>}
     */
    async function createClients(clients) {

        let calls = [];
        let bx24 = new BX24Wrapper();

        let resultClients = {};

        let existingClients = await bx24.callListMethod('crm.contact.list',
            {
                order: { "NAME": "ASC" },
                filter: {},
                select: ["ID", "UTM_CONTENT"]
            });

        for (const key of Object.keys(clients)) {
            let client = clients[key];

            for (let existingClient of existingClients) {
                if (typeof existingClient.UTM_CONTENT === typeof undefined) {
                    continue;
                }
                if (existingClient.UTM_CONTENT == 'RetailCRM_ID=' + client.id) {
                    resultClients[client.id] = existingClient.ID;
                }
            }
            if (typeof resultClients[client.id] === typeof undefined) {
                calls.push(['crm.contact.add', {
                    fields: {
                        NAME: client.firstName,
                        LAST_NAME: client.lastName,
                        EMAIL: client.email !== null ? [{ VALUE: client.email, VALUE_TYPE: 'WORK' }] : '',
                        WEB: client.site,
                        ADDRESS_CITY: client.address !== null ? client.address.city : '',
                        ADDRESS: client.address !== null ? client.address.text : '',
                        PHONE: (client.phones !== null && client.phones.length > 0) ? [{
                            VALUE: client.phones[0].number,
                            VALUE_TYPE: 'WORK'
                        }] : '',
                        UTM_CONTENT: 'RetailCRM_ID=' + client.id
                    }
                }]);
            }
        }
        if (calls.length > 0) {
            await bx24.callLongBatch(calls);
            let existingClients = await bx24.callListMethod('crm.contact.list',
                {
                    order: { "NAME": "ASC" },
                    filter: {},
                    select: ["ID", "UTM_CONTENT"]
                });
            for (const key of Object.keys(clients)) {
                let client = clients[key];
                for (let existingClient of existingClients) {
                    if (typeof existingClient.UTM_CONTENT === typeof undefined) {
                        continue;
                    }
                    if (existingClient.UTM_CONTENT == 'RetailCRM_ID=' + client.id) {
                        resultClients[client.id] = existingClient.ID;
                    }
                }
            }
        }

        setClientsLoaded(true);
        return resultClients;
    }

    /**
     * Создать товары
     * @returns {Promise<{}>}
     * @param products
     * @param groups
     */
    async function createProducts(products, groups) {

        let bx24 = new BX24Wrapper();
        let calls = [];

        let resultProducts = {};
        let createDelivery = true;


        let existingProducts = await bx24.callListMethod('crm.product.list',
            {
                order: { "NAME": "ASC" },
                filter: {},
                select: ["ID", "NAME", "XML_ID"]
            });
        console.log('existingProducts', existingProducts);
        for (const key of Object.keys(products)) {
            let product = products[key];

            let sectionId = product.groups.length > 0 ? groups[product.groups[0].id] : 0;

            if (product.NAME == "Доставка") {
                createDelivery = false;
            }

            for (let existingProduct of existingProducts) {
                if (existingProduct.XML_ID == product.id ||
                    existingProduct.NAME == product.name ||
                    existingProduct.XML_ID == product.article) {
                    resultProducts[product.id] = existingProduct.ID;
                }
            }
            if (typeof resultProducts[product.id] === typeof undefined) {

                calls.push(['crm.product.add', {
                    fields:
                    {
                        NAME: product.name,
                        PRICE: product.maxPrice,
                        SECTION_ID: sectionId,
                        ACTIVE: 'Y',
                        XML_ID: product.article ? product.article : product.id,
                        QUANTITY: product.quantity
                    }
                }
                ]);
            }
        }


        if (calls.length > 0) {
            if (createDelivery) {
                calls.push(['crm.product.add', {
                    fields:
                    {
                        NAME: 'Доставка',
                        PRICE: 100,
                        ACTIVE: 'Y',
                    }
                }
                ]);
            }


            // снять
            await bx24.callLongBatch(calls);

            let existingProducts = await bx24.callListMethod('crm.product.list',
                {
                    order: { "NAME": "ASC" },
                    filter: {},
                    select: ["ID", "NAME", "XML_ID"]
                });

            for (const key of Object.keys(products)) {
                let product = products[key];
                for (let existingProduct of existingProducts) {
                    if (existingProduct.XML_ID == product.id || existingProduct.NAME == product.name) {
                        resultProducts[product.id] = existingProduct.ID;
                    }
                }
            }
        } else if (createDelivery) {
            calls = [];
            calls.push(['crm.product.add', {
                fields:
                {
                    NAME: 'Доставка',
                    PRICE: 100,
                    ACTIVE: 'Y',
                }
            }
            ]);
            await bx24.callLongBatch(calls);
        }

        setProductsLoaded(true);
        return resultProducts;
    }

    /**
     * Создать группы товаров
     * @param groups
     * @returns {Promise<void>}
     */
    async function createGroupsProducts(groups) {
        let bx24 = new BX24Wrapper();

        let calls = [];

        calls.push([
            'crm.productsection.list',
            {
                order: { "NAME": "ASC" },
                filter: {},
                select: ["ID", "NAME"]
            }
        ]);
        let existingCategories = await bx24.callLongBatch(calls);
        existingCategories = existingCategories[0];

        let resultCategories = {};

        calls = [];

        for (const key of Object.keys(groups)) {
            let group = groups[key];
            for (let existingCategory of existingCategories) {
                if (existingCategory.NAME == group.name) {
                    resultCategories[group.id] = existingCategory.ID;
                }
            }
            if (typeof resultCategories[group.id] === typeof undefined) {
                calls.push(['crm.productsection.add', { fields: { NAME: group.name, XML_ID: group.id } }]);
            }
        }
        if (calls.length > 0) {
            // снять
            await bx24.callLongBatch(calls);
            calls = [];

            calls.push([
                'crm.productsection.list',
                {
                    order: { "NAME": "ASC" },
                    filter: {},
                    select: ["ID", "NAME"]
                }
            ]);
            let existingCategories = await bx24.callLongBatch(calls);
            existingCategories = existingCategories[0];
            for (const key of Object.keys(groups)) {
                let group = groups[key];
                for (let existingCategory of existingCategories) {
                    if (existingCategory.NAME == group.name) {
                        resultCategories[group.id] = existingCategory.ID;
                    }
                }
            }


        }
        setGroupsProductsLoaded(true);
        return resultCategories;
    }


    /**
     * Создать пользователей
     * @param users
     * @param groups
     */
    async function createUsers(users, groups) {
        let bx24 = new BX24Wrapper();
        let calls = [];
        calls.push(['user.search', {
            sort: "ID",
            order: 'ASC',
            FILTER: {},
            ADMIN_MODE: true
        }]);
        let existingUsers = await bx24.callLongBatch(calls);

        calls = [];
        let newUsers = {};
        let resultUsers = {};
        Object.keys(users).forEach(function (key) {
            let user = users[key];
            //user.email = 'user' + key + '@severcode.ru'; // @todo hide
            for (let existingUser of existingUsers[0]) {
                if (existingUser.EMAIL == user.email) {
                    resultUsers[user.id] = existingUser.ID;
                    return;
                }
            }

            newUsers[user.id] = {
                'old_id': user.id,
                'email': user.email
            }


            calls.push(['user.add', {
                EMAIL: user.email,
                NAME: user.firstName,
                LAST_NAME: user.lastName,
                PERSONAL_PHONE: user.phone,
                UF_DEPARTMENT: [1]

            }]);
        });

        if (calls.length > 0) {
            await bx24.callLongBatch(calls);
        }
        setUsersLoaded(true);
        return resultUsers;
    }

    async function getNewUsers(users) {
        let bx24 = new BX24Wrapper();
        let calls = [];
        let resultUsers = {};
        calls.push(['user.search', {
            ADMIN_MODE: true
        }]);
        let existingUsers = await bx24.callLongBatch(calls);
        //console.log('existingUsers', existingUsers);
        Object.keys(users).forEach(function (key) {
            let user = users[key];

            for (let existingUser of existingUsers[0]) {
                //console.log(">>", existingUser, user);
                if (existingUser.EMAIL == user.email) {
                    resultUsers[user.id] = existingUser.ID;
                    break;
                }
            }

        });

        return resultUsers;
    }

    async function userSetDepartmentId(usersB24, retailCrmUsers, groups) {

        let bx24 = new BX24Wrapper();
        let calls = [];

        Object.keys(retailCrmUsers).forEach(function (key) {
            let user = retailCrmUsers[key];
            let userGroups = [];
            user.groups.forEach(function (userGroup) {
                let checkGroup = findUserGroup(userGroup.id, groups);
                userGroups.push(checkGroup);
            });

            if (userGroups.length == 0) {
                userGroups.push('1');
            }

            /*calls.push([
                'user.update',
                {
                    ID: usersB24[user.id] == undefined ? usersB24[key] : usersB24[user.id],
                    UF_DEPARTMENT: userGroups
                }
            ]);*/

        });

        console.log('usersB24', usersB24);


        if (calls.length > 0) {
            await bx24.callLongBatch(calls);
        }

    }

    /**
     * Подбор группы юзера
     * @param oldId
     * @param groups
     * @returns {boolean}
     */
    function findUserGroup(oldId, groups) {
        for (const key of Object.keys(groups)) {
            let group = groups[key];
            if (group.old_id == oldId) {
                return group.id;
            }
        }
        return false;
    }

    /**
     * Создание групп в б24
     * @param groups
     */
    async function createGroups(groups) {
        let bx24 = new BX24Wrapper();
        let calls = [];
        let newGroups = {};
        console.log(groups);
        calls.push(['department.get', {}]);
        let b24groups = await bx24.callLongBatch(calls);
        calls = [];
        groups.forEach(function (group) {
            newGroups[group.name] = {
                'old_id': group.id
            };
            for (let b24group of b24groups[0]) {
                if (b24group.NAME == group.name) {
                    newGroups[group.name]['id'] = b24group.ID;
                }
            }
            if (typeof newGroups[group.name]['id'] === typeof undefined) {
                calls.push(['department.add', { NAME: group.name, PARENT: 1 }]);
            }
        });
        if (calls.length > 0) {
            await bx24.callLongBatch(calls);
            await timeout(1000);
        }


        b24groups[0].forEach(function (b24group) {
            if (typeof newGroups[b24group.NAME] === typeof undefined) {
                return;
            }
            newGroups[b24group.NAME]['id'] = b24group.ID;
        });
        setGroupsLoaded(true);
        return newGroups;
    }

    async function getGroupsUsers() {
        let res = (await axios.post('/api/groupsUsers', {
            apiKey: retailCrmKey,
            apiServer: retailCrmAddress
        })).data;
        if (!res.status) {
            console.error(res.error);
            openErrorPage();
        }
        return res;
    }

    async function getUsers() {
        let res = (await axios.post('/api/users', {
            apiKey: retailCrmKey,
            apiServer: retailCrmAddress
        })).data;
        if (!res.status) {
            console.error(res.error);
            openErrorPage();
        }
        return res;
    }

    async function getGroupsProducts() {
        let res = (await axios.post('/api/groupsProducts', {
            apiKey: retailCrmKey,
            apiServer: retailCrmAddress
        })).data;
        if (!res.status) {
            console.error(res.error);
            openErrorPage();
        }
        return res;
    }


    async function getProducts() {
        let res = (await axios.post('/api/products', {
            apiKey: retailCrmKey,
            apiServer: retailCrmAddress
        })).data;
        if (!res.status) {
            console.error(res.error);
            openErrorPage();
        }
        return res;
    }


    async function getClients() {
        let res = (await axios.post('/api/clients', {
            apiKey: retailCrmKey,
            apiServer: retailCrmAddress
        })).data;
        if (!res.status) {
            console.error(res.error);
            openErrorPage();
        }
        return res;
    }

    async function getOrders() {
        let res = (await axios.post('/api/orders', {
            apiKey: retailCrmKey,
            apiServer: retailCrmAddress
        })).data;
        if (!res.status) {
            console.error(res.error);
            openErrorPage();
        }
        return res;
    }

    async function getTasks() {
        let res = (await axios.post('/api/tasks', {
            apiKey: retailCrmKey,
            apiServer: retailCrmAddress,
        })).data;
        if (!res.status) {
            console.error(res.error);
            openErrorPage();
        }
        return res;
    }

    function openErrorPage() {
        history.push("/error");
        return true;
    }

    function openSuccessPage() {
        history.push("/success");
        return true;
    }

    return (
        <div className="LoadingPage">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="title">
                            Загрузка данных
                        </div>
                    </div>

                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="loading-state">
                            <div className={`item groupsUsers  ${groupsLoaded ? 'done' : ''}`}>группы пользователей
                            </div>
                            <div className={`item users ${usersLoaded ? 'done' : ''}`}>пользователи</div>
                            <div className={`item groupsProducts ${groupsProductsLoaded ? 'done' : ''} `}>группы
                                товаров
                            </div>
                            <div className={`item products ${productsLoaded ? 'done' : ''}`}>товары</div>
                            <div className={`item clients ${clientsLoaded ? 'done' : ''}`}>клиенты</div>
                            <div className={`item orders ${ordersLoaded ? 'done' : ''}`}>заказы</div>
                            <div className={`item tasks ${tasksLoaded ? 'done' : ''}`}>задачи</div>

                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-2 offset-10 text-right">
                        <div className="paging">
                            4 / 5
                        </div>
                    </div>
                </div>

            </div>
            <div className="spinner rotating"></div>
        </div>
    );
}

export default LoadingPage;
